export const commissionTemplatesEn = {
  //START MICHAEL
  COMMISSION_TEMPLATES: 'Commission Templates',
  COMMISSION_TEMPLATE: 'Commission Template',
  TEMPLATE_NAME: 'Template Name',
  DESCRIPTION: 'Description',
  FEE_TYPES: 'Fee Types',
  FEE_TYPE: 'Fee Type',
  COMMISSION_PERCENT_BASED_ON: 'Commission % Based On',
  BASE_COMMISSION_PERCENT: 'Base Commission %',
  HAS_BONUSES: 'Has Bonuses',
  TIER_TYPE: 'Tier Type',
  TIER_FIXED_DATE: 'Tier Fixed Date',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CREATE_COMMISSION_TEMPLATE: 'Create Commission Template',
  UPDATE_COMMISSION_TEMPLATE: 'Update Commission Template',
  COMMISSION_TEMPLATE_CREATED_SUCCESSFULLY: 'Commission template created successfully',
  COMMISSION_TEMPLATE_UPDATED_SUCCESSFULLY: 'Commission template updated successfully',

  // Tier Types
  FIRST_FUNDING: 'First Funding',
  FIXED_DATE: 'Fixed Date',

  // Fee Types
  PURCHASE_FEE: 'Purchase Fee',
  COLLECTION_FEE: 'Collection Fee',
  PORTFOLIO_INTEREST_FEE: 'Portfolio Interest Fee',
  ADDITIONAL_FEE: 'Additional Fee',
  NEGATIVE_INTEREST_FEE: 'Negative Interest Fee',
  PAYMENT_FEES: 'Payment Fees',
  QP_FEE: 'QP Fee',
  COST_OF_FUNDS: 'Cost of Funds',
  TIER_COMMISSION: 'Tier Commission',
  TIER_COMMISSION_MESSAGE: 'After the final tier, the base commission will be applied.',
  TIER: 'Tier',
  START_DAY: 'Start Day',
  END_DAY: 'End Day',
  COMMISSION_PERCENT: 'Commission %',
  DESCRIPTION_MAX_LENGTH_ERROR: 'Description cannot exceed 500 characters.',
  FIRST_FUNDING_BONUS: 'First Funding Bonus',
  ENABLE_FIRST_FUNDING_BONUS: 'Enable First Funding Bonus',
  BONUS_AMOUNT: 'Bonus Amount',
  THRESHOLD_BONUSES: 'Threshold Bonuses',
  THRESHOLD_AMOUNT: 'Threshold Amount',
  ADD_THRESHOLD_BONUS: 'Add Threshold Bonus',
  THRESHOLD_BONUS_NOTE: 'Threshold bonuses are cumulative when fee total reaches each threshold.',
  FIRST_FUNDING_BONUS_AMOUNT_REQUIRED: 'First funding bonus amount is required when bonus is enabled.',
  FIRST_FUNDING_BONUS_AMOUNT_INVALID: 'First funding bonus amount must be greater than 0.',
  FIRST_FUNDING_BONUS_NOTE: 'This bonus is always paid on the funding date, regardless of the "Commission Based On" setting.',
  THRESHOLD_BONUS_VALUES_REQUIRED: 'Threshold amount and bonus amount are required for each threshold bonus.',
  THRESHOLD_BONUS_AMOUNT_INVALID: 'Bonus amount must be greater than 0 for each threshold bonus.',
  //END MICHAEL
}

export const commissionTemplatesEs: typeof commissionTemplatesEn = {
  //START MICHAEL
  COMMISSION_TEMPLATES: 'Plantillas de Comisión',
  COMMISSION_TEMPLATE: 'Plantilla de Comisión',
  TEMPLATE_NAME: 'Nombre de Plantilla',
  DESCRIPTION: 'Descripción',
  FEE_TYPES: 'Tipos de Tarifa',
  FEE_TYPE: 'Tipo de Tarifa',
  COMMISSION_PERCENT_BASED_ON: 'Comisión % Basada En',
  BASE_COMMISSION_PERCENT: '% Comisión Base',
  HAS_BONUSES: 'Tiene Bonos',
  TIER_TYPE: 'Tipo de Nivel',
  TIER_FIXED_DATE: 'Fecha Fija de Nivel',
  ACTIVE: 'Activo',
  INACTIVE: 'Inactivo',
  CREATE_COMMISSION_TEMPLATE: 'Crear Plantilla de Comisión',
  UPDATE_COMMISSION_TEMPLATE: 'Actualizar Plantilla de Comisión',
  COMMISSION_TEMPLATE_CREATED_SUCCESSFULLY: 'Plantilla de comisión creada con éxito',
  COMMISSION_TEMPLATE_UPDATED_SUCCESSFULLY: 'Plantilla de comisión actualizada con éxito',

  // Tier Types
  FIRST_FUNDING: 'Primer Financiamiento',
  FIXED_DATE: 'Fecha Fija',

  // Fee Types
  PURCHASE_FEE: 'Tarifa de Compra',
  COLLECTION_FEE: 'Tarifa de Cobranza',
  PORTFOLIO_INTEREST_FEE: 'Tarifa de Interés de Portafolio',
  ADDITIONAL_FEE: 'Tarifa Adicional',
  NEGATIVE_INTEREST_FEE: 'Tarifa de Interés Negativo',
  PAYMENT_FEES: 'Tarifas de Pago',
  QP_FEE: 'Tarifa QP',
  COST_OF_FUNDS: 'Costo de Fondos',
  TIER_COMMISSION: 'Comisión de Nivel',
  TIER_COMMISSION_MESSAGE: 'Después del nivel final, se aplicará la comisión base.',
  TIER: 'Nivel',
  START_DAY: 'Día de Inicio',
  END_DAY: 'Día Final',
  COMMISSION_PERCENT: '% Comisión',
  DESCRIPTION_MAX_LENGTH_ERROR: 'La descripción no puede exceder los 500 caracteres.',
  FIRST_FUNDING_BONUS: 'Bono de Primer Fondeo',
  ENABLE_FIRST_FUNDING_BONUS: 'Habilitar Bono de Primer Fondeo',
  BONUS_AMOUNT: 'Monto del Bono',
  THRESHOLD_BONUSES: 'Bonos por Umbral',
  THRESHOLD_AMOUNT: 'Monto Umbral',
  ADD_THRESHOLD_BONUS: 'Agregar Bono por Umbral',
  THRESHOLD_BONUS_NOTE: 'Los bonos por umbral son acumulativos cuando el total de tarifas alcanza cada umbral.',
  FIRST_FUNDING_BONUS_AMOUNT_REQUIRED:
    'El monto del bono de primer fondeo es requerido cuando el bono está habilitado.',
  FIRST_FUNDING_BONUS_AMOUNT_INVALID: 'El monto del bono de primer fondeo debe ser mayor a 0.',
  FIRST_FUNDING_BONUS_NOTE: 'Este bono siempre se paga en la fecha de funding, independientemente de la configuración "Comisión Basada En".',
  THRESHOLD_BONUS_VALUES_REQUIRED: 'El monto umbral y el monto del bono son requeridos en cada bono por umbral.',
  THRESHOLD_BONUS_AMOUNT_INVALID: 'El monto del bono debe ser mayor a 0 en cada bono por umbral.',
  //END MICHAEL
}
